import { ENEMIES } from '../core/SimConfig.js';
import { rand } from '../utils.js';

/**
 * Permanent crash-site fires — the burning patch an enemy aircraft leaves
 * where it hit the deck. An aircraft wreck is removed from the scene on impact
 * (its model is buried in the terrain by then), so the fire can't hang off the
 * entity the way a ground vehicle's wreck fire does; instead each site is just
 * a point that keeps emitting the same buoyant `spawnGroundFireSmokeTrail`
 * plume a destroyed vehicle does, at the same sparse random cadence, for the
 * rest of the scenario.
 *
 * No geometry of its own, so a site costs one timer and a couple of particles
 * a few times a second.
 */
export default class GroundFireSystem {
  constructor(particleSystem) {
    this.particleSystem = particleSystem;
    this.fires = [];
  }

  /** Start a fire at ground level (x, y, z). Burns until dispose(). */
  add(x, y, z) {
    const cfg = ENEMIES.crashFire;
    this.fires.push({
      x, y: y + cfg.heightOffset, z,
      timer: rand(cfg.interval.min, cfg.interval.max),
    });
  }

  update(dt) {
    if (!this.particleSystem) return;
    const { interval, scatter } = ENEMIES.crashFire;
    for (const f of this.fires) {
      f.timer -= dt;
      if (f.timer > 0) continue;
      f.timer = rand(interval.min, interval.max);
      // Jitter the source across the debris field so the column doesn't read
      // as one point emitter standing on the ground.
      this.particleSystem.spawnGroundFireSmokeTrail(
        f.x + rand(-scatter, scatter), f.y, f.z + rand(-scatter, scatter),
        0, 0, 0);
    }
  }

  dispose() {
    this.fires.length = 0;
  }
}
